import { useEffect, useRef } from "react";
import scrollIntoView from "scroll-into-view-if-needed";
export default function useScrollCommentIntoView(match) {
    const ref = useRef(null);
    /**
   * Why is `setTimeout` needed? Not entirely sure. It probably has something
   * to do with how browsers restore scroll position by default.
   */ useEffect(()=>{
        let timeoutId;
        const element = ref.current;
        if (match && element) timeoutId = setTimeout(()=>{
            scrollIntoView(element, {
                block: "center"
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        match
    ]);
    return {
        ref
    };
};
